<template>
    <modal
        class="login-modal"
        :adaptive="true"
        :scrollable="true"
        name="authentication-forms-modal"
        height="auto"
        width="410"
        @before-open="beforeOpen"
    >
        <div class="close-modal" @click="$modal.hide('authentication-forms-modal')">
            <img src="@assets/img/x-gray.svg" alt="">
        </div>
        <notifications group="app-notifications" />


        <div v-if="currentForm === 'sign-in'" class="auth-form">
            <audiobooks-login-form v-if="$route.meta.group == 'hibooks'" :use-route-handler="false" @auth-sucessfull="signInSuccessful" />
            <insights-login-form
                v-else
                :opened-in-modal="true"
                :use-route-handler="false"
                @auth-sucessfull="signInSuccessful"
            >
                <template v-slot:sign-up-link>
                    <p class="log-in-link">
                        Don't have an account?
                        <a
                            class="text-primary"
                            href="javascript: void(0)"
                            @click="onSignUpClicked"
                        >
                            Sign Up
                        </a>
                    </p>
                </template>
            </insights-login-form>
        </div>
        <div v-else class="auth-form">
            <insights-sign-up-landing-form
                :tracking-properties="trackingProperties"
                :opened-in-modal="true"
                :use-route-handler="false"
                @auth-sucessfull="signUpSucessful"
            >
                <template v-slot:sign-in-link>
                    <p class="log-in-link">
                        Already have an account?
                        <a
                            class="text-primary"
                            href="javascript: void(0)"
                            @click="onSignInClicked"
                        >
                            Sign in
                        </a>
                    </p>
                </template>
            </insights-sign-up-landing-form>
        </div>
    </modal>
</template>

<script>

import _isEmpty from "lodash/isEmpty";

export default {
    name: "AuthenticationFormsModal",
    components: {
        insightsLoginForm: () => import(/* webpackChunkName: "insights-login-form"*/ "@c/auth/sign-in/insights"),
        insightsSignUpLandingForm: () => import(/* webpackChunkName: "insights-sign-up-landing-form"*/ "@c/auth/sign-up/insights-landing")
    },
    data() {
        return {
            addToLibraryAction: "",
            currentForm: "",
            trackingProperties: {
                pageUrl: `${process.env.VUE_APP_DOMAIN}${this.$route.fullPath}`,
                button: this.addToLibraryAction ? "bi_hero_add_to_my_library" : "menu_sign_up_cta"
            }
        }
    },
    methods: {
        beforeOpen(event) {
            if (_isEmpty(event.params)) {
                return;
            }

            this.addToLibraryAction = event.params.action;
            this.currentForm = event.params.formType;
        },
        signInSuccessful() {
            this.$nextTick(() => {
                this.$store.dispatch("Application/getGlobalStateData").then(() => {
                    if (this.addToLibraryAction === "add-to-library") {
                        this.$emit("add-to-library");
                    }

                    this.$modal.hide("authentication-forms-modal")
                });
            });
        },
        signUpSucessful(user, includeUserInNewsletter = false) {
            this.$nextTick(() => {
                this.$store.dispatch("Application/getGlobalStateData").then(() => {
                    if (includeUserInNewsletter) {
                        this.$emit("subscribe-to-newsletter", user);
                    }

                    if (this.addToLibraryAction === "add-to-library") {
                        this.$emit("add-to-library");
                    }

                    this.$modal.hide("authentication-forms-modal");
                });
            });
        },
        onSignInClicked() {
            this.currentForm = "sign-in";
        },
        onSignUpClicked() {
            this.currentForm = "sign-up"
        }
    }
}
</script>

<style lang="scss">
.login-modal {
    .v--modal-box {
        overflow: visible;
        border-radius: 10px;

        @media (max-width: $md) {
            border-radius: 0;
        }
    }

    .close-modal {
        position: absolute;
        right: -23px;
        top: -23px;
        width: 24px;
        height: 24px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $medium-gray;
        padding: 5px;
        cursor: pointer;

        img {
            width: 100%;
        }

        @media (max-width: $md) {
            right: 5px;
            top: 5px;
        }
    }

    @media (max-width: $md) {
        .auth-form {
            padding: 20px !important;
            margin: 0 auto;
        }
    }

}
</style>
